import script from "./MsgBoxOkCancel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgBoxOkCancel.vue?vue&type=script&setup=true&lang=ts"

import "./MsgBoxOkCancel.vue?vue&type=style&index=0&id=0026e152&lang=css"

const __exports__ = script;

export default __exports__